module.exports = __webpack_public_path__ + "static/media/meet-preview.6690fc39.png";